import { runFunction } from "../../http";
import { SettingSettingData } from "../../../types";

export const getAppSettings = async (): Promise<SettingSettingData> => {
  console.debug("[Service] getAppSettings");
  const settings: SettingSettingData = await runFunction("getAppSettings");
  return settings;
};
